import moment from 'moment';
import esDayjs from 'dayjs/locale/es';
import enDayjs from 'dayjs/locale/en';
import i18n, { DEFAULT_LANGUAGE } from 'i18n';

type DayjsLocale = typeof esDayjs;

const months = (): string[] =>
  i18n.t('dates.months', { returnObjects: true }) as unknown as string[];

const weekdaysMin = (): string[] =>
  i18n.t('dates.weekdaysMin', { returnObjects: true }) as unknown as string[];

export const applyMomentLocale = (
  localeId: string,
  { startWeekOnMonday = false }: { startWeekOnMonday?: boolean } = {}
): void => {
  moment.updateLocale(localeId, {
    ...(startWeekOnMonday ? { week: { dow: 1 } } : {}),
    weekdaysMin: weekdaysMin(),
  });

  moment.updateLocale(localeId, { months: months() });
};

const dayjsLocales: Record<string, DayjsLocale> = {
  es: esDayjs,
  en: enDayjs,
};

export const getDayjsLocale = (language: string): DayjsLocale =>
  dayjsLocales[language] ?? dayjsLocales[DEFAULT_LANGUAGE];

export default applyMomentLocale;
